import React, { useEffect, useState } from 'react';
import Logo from '../../assets/icons/popup/E-Lotto Logo.svg?react';
import GameImage1 from '../../assets/icons/popup/Super-Lotto-649.webp';
import BgLatto from '../../assets/images/bg-latto.jpg';

export default function HowToPlay({ isOpen, onClose, selectedGame }) {
  const [isVisible, setIsVisible] = useState(isOpen);
  const [isAnimating, setIsAnimating] = useState(false);

  let gameName = selectedGame?.name;

  if(gameName && ["3D", "S2", "LAST3", "PICK3", "2D"].includes(gameName.split(' ')[0])){
    gameName = gameName.split(' ')[0];
  }else if(gameName && ["LAST"].includes(gameName.split(' ')[0]) && ["2"].includes(gameName.split(' ')[1])){
    gameName = gameName.split(' ')[0] + ' ' + gameName.split(' ')[1];
  }
  else{
    gameName = selectedGame?.name;
  }

  useEffect(() => {
    if (isOpen) {
      setIsVisible(true);
      setTimeout(() => setIsAnimating(true), 10); // Small delay to trigger transition
    } else {
      setIsAnimating(false);
      const timer = setTimeout(() => setIsVisible(false), 300); // Wait for animation to finish
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  if (!isVisible) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  // Replace scheduleData with gameData containing name, mechanics, and drawTime
  const gameData = [
    {
      name: '3D',
      mechanics: 'Select a 3-digit number (000-999). Exact match wins.',
      drawTime: '2:00 PM, 5:00 PM and 9:00 PM',
      genName: '3D'
    },
    {
      name: '2D',
      mechanics: 'Pick any 2-digit combination (e.g., 10-09 or 01-01).',
      drawTime: '2:00 PM, 5:00 PM and 9:00 PM',
      genName: '2D'
    },
    {
      name: 'PICK 3',
      mechanics: 'Select 3 number combination from 1 to 42.',
      drawTime: '9:00 PM',
      genName: 'PICK3'
    },
    {
      name: 'LAST 3',
      mechanics: 'Select a 3-digit number. Result is based on the last 3 digits of 4D/6D draw.',
      drawTime: '9:00 PM',
      genName: 'LAST3'
    },
    {
      name: 'LAST 2',
      mechanics: 'Select a 2-digit number. Result is based on the last 2 digits of 4D/6D draw.',
      drawTime: '2:00 PM, 5:00 PM and 9:00 PM',
      genName: 'LAST 2'
    },
    {
      name: 'S2',
      mechanics: 'Select a 2-digit number. Result is based on the last 2 digits of 3D draw.',
      drawTime: '2:00 PM, 5:00 PM and 9:00 PM',
      genName: 'S2'
    },
    {
      name: 'STL GENSAN',
      mechanics: 'Pick a 3-digit number (000-999). Result is based on Gensan STL draw.',
      drawTime: '10:30 AM, 3:00 PM, and 7:30 PM',
      genName: 'STL GNSAN'
    },
    {
      name: 'STL MANDAUE',
      mechanics: 'Pick a 3-digit number (000-999). Result is based on Mandaue STL draw.',
      drawTime: '10:30 AM, 3:00 PM, and 7:00 PM',
      genName: 'STL MNDAUE'
    },
    {
      name: 'STL BUKIDNON',
      mechanics: 'Pick a 3-digit number (000-999). Result is based on Bukidnon STL draw.',
      drawTime: '10:30 AM, 3:00 PM, and 8:00 PM',
      genName: 'STL BUK'
    },
    {
      name: 'STL MIS OR',
      mechanics: 'Pick a 3-digit number (000-999). Result is based on Misamis Oriental STL draw.',
      drawTime: '11:00 AM, 4:00 PM, and 8:00 PM',
      genName: 'STL MSOR'
    },
    {
      name: 'STL CDO',
      mechanics: 'Pick a 3-digit number (000-999). Result is based on Cagayan De Oro STL draw.',
      drawTime: '11:00 AM, 4:00 PM, and 8:00 PM',
      genName: 'STL CDO'
    },
  ];

  return (
    <div
      className={`fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50 font-poppins transition-opacity duration-300 ${
        isAnimating ? 'opacity-100' : 'opacity-0'
      } overflow-y-auto`}
      onClick={handleBackdropClick}
      style={{ maxHeight: '100vh' }}
    >
      <div
        className={`relative w-full max-w-sm rounded-3xl overflow-hidden transform transition-all duration-300 ease-in-out ${
          isAnimating ? 'scale-100 opacity-100' : 'scale-95 opacity-0'
        } bg-white/0`}
        style={{ maxHeight: '90vh' }}
      >
        {/* Background with gradient and floating elements */}
        <div
          className='absolute inset-0'
          style={{
            backgroundImage: `url('${BgLatto}'), linear-gradient(132.14deg, #0279F9 0%, #293CA8 40%, #D42F55 100%)`,
            backgroundBlendMode: 'soft-light',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        ></div>

        {/* Content */}
        <div className='relative text-center overflow-y-auto' style={{ maxHeight: '90vh' }}>
          {/* Close button */}
          <button
            onClick={onClose}
            className='absolute right-4 top-4 text-white/80 hover:text-white transition-colors'
            aria-label='Close'
            type='button'
          >
            <svg
              className='w-6 h-6'
              fill='none'
              stroke='currentColor'
              viewBox='0 0 24 24'
            >
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth={2}
                d='M6 18L18 6M6 6l12 12'
              />
            </svg>
          </button>

          {/* Logo */}
          <div className='flex justify-center gap-2.5 my-5 max-xs:my-3 text-white'>
            <Logo />
            <h3
              style={{
                textShadow:
                  '2px 2px 4px rgba(0, 0, 0, 0.25), 1px 1px 2px #FF9304',
              }}
              className='text-2xl font-semibold  text-left leading-none max-xs:text-lg  max-xs:leading-4 max-xs:my-3'
            >
              LOTTO DRAWS <br /> SCHEDULE
            </h3>
          </div>

          {/* Ticket section start */}

          {/* Schedule List replaced with Game Mechanics List */}
          <div className='space-y-3 mx-4 mb-4'>
            {gameData.map((game, idx) => (
              gameName === game.genName && (
              <div
                key={game.name}
                className='bg-white/90 rounded-xl px-4 py-3 shadow flex flex-col gap-1 text-left border border-blue-100'
              >
                <div className='font-bold text-blue-900 text-lg'>{game.name}</div>
                <div className='text-gray-700 text-sm'><span className='font-semibold text-blue-700'>Mechanics:</span> {game.mechanics}</div>
                <div className='text-gray-600 text-xs'><span className='font-semibold text-pink-700'>Draw Time:</span> {game.drawTime}</div>
              </div>
              )
            ))}
          </div>

          {/* Ticket section end */}
        </div>
      </div>
    </div>
  );
}
